// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PUnlikeOutlinedSvg from "@fishx/icons-svg/es/asn/PUnlikeOutlined";
import FishxIcon from '../components/FishxIcon';

var PUnlikeOutlined = function PUnlikeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PUnlikeOutlinedSvg
  }));
};

PUnlikeOutlined.displayName = 'PUnlikeOutlined';
export default React.forwardRef(PUnlikeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PUnlikeOutlined.js
// module id = 3697
// module chunks = 0